<template>
    <div>
        <!-- Begin Page Content -->
        <div class="medical-records cart-section h-100">
            <div class="row h-100">
                <div class="col-12 mb-4 Order Confirmed h-100">
                    <div class="bg-white border-radius-5 p-5 Order h-100">
                        <div class="card border-0">
                            <div class="card-body p-0">
                                <div class="row justify-content-center order-confirmed pt-3">
                                    <div class="col-md-5 text-center">
                                        <i class="icon icon-check mb-4"></i>
                                        <h3>Thank You</h3>
                                        <p>Your Order has been Confirmed!</p>
                                        <router-link class="btn btn-blue go-to-shop" to="/stop-medicine-delivery">Back to Prescription</router-link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- End of Page Wrapper -->
</template>
<script>
    export default {
        name: "prescription-order-confirm",
        data() {
            return {};
        },
        created(){
           this.pageName('Order Confirmed')
        }
    };
</script>



// WEBPACK FOOTER //
// src/components/website/prescription/prescription-order-confirm.vue